import { ref } from "vue";

export function usePromoCodeClipboard(code: string) {
  const copied = ref(false);
  const showToast = ref(false);
  let toastTimer: ReturnType<typeof setTimeout> | null = null;
  let resetTimer: ReturnType<typeof setTimeout> | null = null;

  async function copyCode() {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(code).catch(() => {});
    } else {
      const ta = document.createElement("textarea");
      ta.value = code;
      document.body.appendChild(ta);
      ta.select();
      try {
        document.execCommand("copy");
      } catch {
        // ignore — no fallback left if execCommand is unsupported
      }
      document.body.removeChild(ta);
    }

    if (toastTimer) clearTimeout(toastTimer);
    if (resetTimer) clearTimeout(resetTimer);
    copied.value = true;
    showToast.value = true;
    toastTimer = setTimeout(() => {
      showToast.value = false;
    }, 1500);
    resetTimer = setTimeout(() => {
      copied.value = false;
    }, 2000);
  }

  return { copied, showToast, copyCode };
}
